import React from "react";
export default class TemplateTitle extends React.Component {
  constructor(props) {
    super(props);
    this.state = { titleRef: React.createRef() };
  }
  onKeyDown = (e) => {
    if (e.key === "Enter" && this.props.editable) {
      e.preventDefault();
      if (this.state.titleRef.current) {
        this.state.titleRef.current.blur();
      }
      return false;
    }
  };
  onBlur = (e) => {
    if (this.state.titleRef.current && this.props.editable) {
      let newTitle = this.state.titleRef.current.innerHTML.trim();
      if (newTitle && newTitle !== this.props.title)
        this.props.onTitleChange(newTitle);
    }
  };
  onClick = () => {
    if (this.state.titleRef.current && this.props.editable) {
      document.execCommand("selectAll", false, null);
    }
  };
  render() {
    const styles = {
      WebkitUserModify: this.props.editable
        ? "read-write-plaintext-only"
        : "read-only",
      outlineColor: "#3699ff",
      backgroundColor: "#ffffff",
      borderRadius: "5px",
      padding: "5px",
      maxWidth: "1000px",
    };
    return (
      <h5
        ref={this.state.titleRef}
        onKeyDown={this.onKeyDown}
        onBlur={this.onBlur}
        onClick={this.onClick}
        style={styles}
      >
        {this.props.title}
      </h5>
    );
  }
}
